import React from "react";
import {useForm} from "react-hook-form";
import rider from "../../network/services/rider";
import {getCourierBusinessId, getUserPhoneNumber} from "../../helpers/authenticator";
import toastifyHelper from "../../helpers/toastify_helper";
import quick_models from "../../network/models/quick_models";
import general_helper, {getErrorMessage} from "../../helpers/general_helper";

const DeliveryConfirmationModal = ({deliveryItem}) => {
    const {register, handleSubmit, watch, errors} = useForm();


    const onSubmit = (data) => {
        let requestData = quick_models.riderUpdateDeliveryStatusRequest

        requestData.agent_id = getUserPhoneNumber();
        requestData.business_id = getCourierBusinessId();
        requestData.delivery_id = deliveryItem.item.delivery_id;
        requestData.confirmation_code = data.code;
        requestData.status = general_helper.getNextStatus(deliveryItem.item.status);
        requestData.tracking_id = deliveryItem.item.tracking_id;

        rider.riderUpdateDeliveryStatus(getUserPhoneNumber(), deliveryItem.item.delivery_id, requestData).then(response => {
            //Update view with the latest data
            toastifyHelper.toastify.successToastify(response.data.message);
            window.location.reload();
        }).catch(error => {
            toastifyHelper.toastify.errorToastify(error.response.data.message);
        })
    }


    return (
        <>
            <div className="modal fade" id="confirmationModal" tabIndex="-1" role="dialog"
                 aria-labelledby="exampleModalLabel"
                 aria-hidden="true">
                <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title text-center" id="exampleModalLabel">Delivery Confirmation
                                    Code</h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row justify-content-center">
                                    <div className="col-md-6">
                                        <input type="text" style={{fontWeight: 700, fontSize: 25, textAlign: "center"}}
                                               className="form-control form-control-lg input-form-alt" maxLength={4}
                                               name={"code"}
                                               ref={register({
                                                   required: true,
                                                   min: 4,
                                                   max: 4,
                                                   pattern: /[0-9]{4}/
                                               })}
                                               id="recipient-name"/>
                                        {errors.code &&
                                        <small className="small-text-red"> <i
                                            className="fas fa-exclamation-triangle"/>{getErrorMessage(errors.code.type)}
                                        </small>}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer justify-content-center">
                                <button className="btn btn-primary">Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default DeliveryConfirmationModal;
